/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PracticeUserViewModel } from '../models/practice-user-view-model';

@Injectable({
  providedIn: 'root',
})
export class PracticeUserProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation userProfileApiPracticePracticeGet
   */
  static readonly UserProfileApiPracticePracticeGetPath = '/user-profile-api/practice/practice';

  /**
   * Gets the practice user details for the logged in user. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userProfileApiPracticePracticeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProfileApiPracticePracticeGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PracticeUserViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, PracticeUserProfileService.UserProfileApiPracticePracticeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PracticeUserViewModel>;
      })
    );
  }

  /**
   * Gets the practice user details for the logged in user. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userProfileApiPracticePracticeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProfileApiPracticePracticeGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<PracticeUserViewModel> {

    return this.userProfileApiPracticePracticeGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PracticeUserViewModel>) => r.body as PracticeUserViewModel)
    );
  }

  /**
   * Gets the practice user details for the logged in user. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userProfileApiPracticePracticeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProfileApiPracticePracticeGet$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PracticeUserViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, PracticeUserProfileService.UserProfileApiPracticePracticeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PracticeUserViewModel>;
      })
    );
  }

  /**
   * Gets the practice user details for the logged in user. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userProfileApiPracticePracticeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProfileApiPracticePracticeGet$Json(params?: {
  },
  context?: HttpContext

): Observable<PracticeUserViewModel> {

    return this.userProfileApiPracticePracticeGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<PracticeUserViewModel>) => r.body as PracticeUserViewModel)
    );
  }

}
